import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { InsightsHubState } from "@insightsHub/models";
import { fetchInsightsHubArticles } from "@insightsHub/store/thunks";
import { mapStrapiPortalArticle } from "@insightsHub/util/mapStrapiPortalArticle";
import ReduxUtils from "@shared/utils/ReduxUtils";
import { timeRangeOptions } from "@insightsHub/constants";

const initialState: InsightsHubState = {
  data: null,
  filters: {
    timeRange: {
      timePeriod: timeRangeOptions[0],
      start: null,
      end: null,
    },
    selectedFormat: null,
    selectedAuthor: null,
    selectedBusinessSegment: null,
    searchInputKeyword: "",
  },
  loading: false,
  error: null,
};

const insightsHubSlice = createSlice({
  name: "insightsHub",
  initialState,
  reducers: {
    resetState: () => initialState,
    updateInsightFilters: (state, action: PayloadAction<Partial<InsightsHubState["filters"]>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInsightsHubArticles.pending, (state) => ReduxUtils.defaultPendingActionHandler(state))
      .addCase(fetchInsightsHubArticles.fulfilled, (state, action) => {
        const articles = Array.isArray(action.payload?.data) ? action.payload.data : [];

        ReduxUtils.defaultFulfilledActionHandler(
          state,
          articles.map((articleDto) => mapStrapiPortalArticle(articleDto))
        );
      })
      .addCase(fetchInsightsHubArticles.rejected, (state, action) =>
        ReduxUtils.defaultRejectedActionHandler(state, action.payload as string)
      );
  },
});

export const { resetState, updateInsightFilters } = insightsHubSlice.actions;
export default insightsHubSlice.reducer;
